import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/fcc-compliance-statements/content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/PageLayout/index.tsx");
